import styles from './ProductTags.module.css';

function contrastText(hex) {
  if (!hex || typeof hex !== 'string') {
    return '#fff';
  }

  const normalized = hex.replace('#', '');
  if (normalized.length !== 6) {
    return '#fff';
  }

  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  const luminance = (r * 299 + g * 587 + b * 114) / 1000;

  return luminance > 160 ? '#1a1a1a' : '#fff';
}

export function ProductTags({ tags = [], className = '', size = 'md' }) {
  if (!tags.length) {
    return null;
  }

  return (
    <ul className={`${styles.list} ${styles[size] || ''} ${className}`.trim()} aria-label="Теги товара">
      {tags.map((tag) => (
        <li
          key={tag.id}
          className={styles.badge}
          style={{
            backgroundColor: tag.color || 'var(--color-primary)',
            color: contrastText(tag.color),
          }}
        >
          {tag.name}
        </li>
      ))}
    </ul>
  );
}
